import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";

import {
  findGetParameter,
  getData,
} from "../../components/utilities/UtilityFunctions";

import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import RankingsWidgetRegional from "../../components/rankings/RankingsWidgetRegional";
import { useParams } from "react-router";

export default function LeaderboardComponent(props) {
  const {
    regionId,
    appRoute,
    region,
    setLeague,
    gameStore,
    setGameStore,
    regions,
    activeTab,
  } = props;

  let { league } = props;

  if (activeTab === "teams" && league) league.teams = true;

  const { leagueId } = useParams();
  const leagueIdParam = findGetParameter("league");
  const regionIdParam = findGetParameter("region");

  const embed = appRoute || findGetParameter("embed") === "true";

  var armyId = findGetParameter("army");
  if (!armyId) armyId = findGetParameter("faction");

  const [loading, setLoading] = useState(true);
  const [rankingsGroup, setRankingsGroup] = useState(null);

  const compareLeagueId =
    league?.id || props.leagueId || leagueId || leagueIdParam;

  useEffect(() => {
    const go = async () => {
      let apiLeague = league;
      let apiGameStore = gameStore;

      if (!league || (league && league?.id !== compareLeagueId)) {
        apiLeague = await getData(`/leagues/${leagueId || leagueIdParam}`, {
          queryStringParameters: {
            "expand[]": ["gameSystem", "gameStore", "gameStoreUser"],
          },
        });

        if (apiLeague.photoFileId) {
          apiLeague.photo = await getData(`/files/${apiLeague.photoFileId}`, {
            queryStringParameters: {},
          });
        }
        setLeague(apiLeague);
      } else {
        if (
          !apiGameStore &&
          (apiLeague?.gameStoreId || apiLeague?.gameStore?.id)
        ) {
          try {
            apiGameStore = await getData(
              `/gamestores/${
                apiLeague?.gameStoreId || apiLeague?.gameStore?.id
              }`
            );
            setGameStore(apiGameStore);
          } catch {}
        }

        if (armyId) {
          var apiArmy = await getData(`/armies/${armyId}`, {});
          apiArmy.name = apiLeague.name + " - " + apiArmy.name;
          apiArmy.numFactionPlacings = apiLeague.numFactionPlacings;
          apiArmy.itc = apiLeague.itc;
          setRankingsGroup(apiArmy);
        } else {
          setRankingsGroup(apiLeague);
        }

        setLoading(false);
      }
    };

    go();
    // eslint-disable-next-line
  }, [league]);

  return (
    <>
      {loading && <ModalLoadingFull />}
      {!loading && (
        <Container sx={{ pt: 2, pb: 2, textAlign: "center" }} maxWidth="lg">
          {region && (
            <RankingsWidgetRegional
              rankingGroup={rankingsGroup}
              placingsType={activeTab === "teams" ? "team" : null}
              leagueId={props.leagueId || leagueId || leagueIdParam}
              regionId={region?.id || regionId || regionIdParam}
              region={region}
              regions={regions}
              isArmy={armyId}
              doSearch
              doPages
              rowsPerPage={50}
              rowsPerPageArray={[25, 50, 100, { label: "All", value: -1 }]}
              embed={embed}
              hideImage
              hideTitle
              hidePoweredBy
              hideRegionPicker
              disableCookieSet
            />
          )}
        </Container>
      )}
    </>
  );
}
